var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"investments-update-box"},[_c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"inner",style:(`width: ${_vm.percentage}%`)})]),_vm._v(" "+_vm._s(_vm.$t('home.investments_update'))+" ("+_vm._s(_vm.percentage)+"%) ")])
}
var staticRenderFns = []

export { render, staticRenderFns }